/* Las curvas y las poses del prototipo aprobado (`04-dos-logos-3d.html`). Sin `three`. */

export const clamp = (v: number) => Math.max(0, Math.min(1, v));
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
export const rotY = (x: number, z: number, a: number): [number, number] => [
  x * Math.cos(a) - z * Math.sin(a),
  x * Math.sin(a) + z * Math.cos(a),
];

export const E = {
  out: (t: number) => 1 - Math.pow(1 - t, 3),
  back: (t: number) => {
    const c = 1.6;
    return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2);
  },
  io: (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
};

export interface Pose {
  x: number;
  y: number;
  z: number;
  rx: number;
  ry: number;
  rz: number;
  sx: number;
  sy: number;
  sz: number;
  op: number;
}

export const pose = (o: Partial<Pose> = {}): Pose => ({
  x: 0,
  y: 0,
  z: 0,
  rx: 0,
  ry: 0,
  rz: 0,
  sx: 1,
  sy: 1,
  sz: 1,
  op: 1,
  ...o,
});

export const OCULTA = pose({ op: 0 });

export const mezclar = (a: Pose, b: Pose, t: number): Pose => ({
  x: lerp(a.x, b.x, t),
  y: lerp(a.y, b.y, t),
  z: lerp(a.z, b.z, t),
  rx: lerp(a.rx, b.rx, t),
  ry: lerp(a.ry, b.ry, t),
  rz: lerp(a.rz, b.rz, t),
  sx: lerp(a.sx, b.sx, t),
  sy: lerp(a.sy, b.sy, t),
  sz: lerp(a.sz, b.sz, t),
  op: lerp(a.op, b.op, t),
});
